<template>
  <div class="home-page">
    <p class="home-title">亲爱的小伙伴</p>
    <p class="home-title">欢迎来到<span class="bold">数企·21秒云集客</span></p>
    <p class="home-title">请开启下方的<span class="bold yellow">体验之旅</span>吧~</p>
    <div class="guide-wrap">
        <div class="guide-box" v-for="item in companyList" :key="item.name" @click="changeStep(item.code)">
            <div class="guide-title">{{item.name}}分公司</div>
            <div class="guide-enter">点击进入</div>
            <img class="guide-icon" src="@/assets/img/guide/right-arrow.svg" alt="" srcset="">
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [
                { name: '合肥', code: 1 },
                { name: '深圳', code: 2 }
            ]
        };
    },
    methods: {
        changeStep(code) {
            this.$emit('changeStep', { step: 1, company: code });
        }
    }
};
</script>

<style  lang="scss" scoped>
.home-page{
    width: 100%;
    height: 100%;
    background: linear-gradient(#0056FF,#008CFF);
    padding-top: 80px;
    padding-bottom: 100px;
    overflow: auto;
    .home-title{
        height: 36px;
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 36px;
        text-align: left;
        margin-left: 21px;
        .bold{
            font-size: bold;
        }
        .yellow{
            color: #FFF24B;
        }
    }
    .guide-wrap{
        margin-top: 192px;
        padding: 0 27px;
        display: flex;
        justify-content: space-between;
        .guide-box{
            width: 144px;
            height: 192px;
            background: #FFF682;
            border-radius: 19px;
            // backdrop-filter: blur(9px);
            // -webkit-backdrop-filter: blur(9px);
            filter: drop-shadow(#EBD332 7px 8px);
            padding: 50px 0 0 18px;
            display: flex;
            flex-direction: column;
            .guide-title{
                width: 100px;
                height: 17px;
                font-size: 20px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #513E00;
                line-height: 16px;
                margin-bottom: 14px;
            }
            .guide-enter{
                width: 48px;
                height: 17px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #513E00;
                line-height: 16px;
                margin-bottom: 31px;
            }
            .guide-icon{
                width: 21px;
                height: 21px;
            }
        }
    }
}

</style>
